import * as React from "react"
import type { SVGProps } from "react"
const SvgTipJar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M17.71 5.14a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.3H7a1 1 0 0 0-.71.3 1 1 0 0 0-.29.7 1 1 0 0 0 .29.72q.29.3.71.29h10q.42 0 .71-.29m-5.76 13.29a.6.6 0 0 1-.43-.18.6.6 0 0 1-.2-.45v-.18a3 3 0 0 1-1.1-.55 3 3 0 0 1-.73-.88.7.7 0 0 1 0-.57.7.7 0 0 1 .44-.38.8.8 0 0 1 .56 0 1 1 0 0 1 .46.37q.22.3.52.46t.55.17q.5 0 .76-.23.27-.23.27-.51 0-.32-.3-.57a3 3 0 0 0-1.07-.5 4 4 0 0 1-1.63-.9q-.5-.51-.5-1.3a2 2 0 0 1 .43-1.21 2.2 2.2 0 0 1 1.35-.8v-.16q0-.27.18-.45a.6.6 0 0 1 .43-.18q.27 0 .43.18.17.18.17.45v.17q.45.1.86.33.39.23.66.62.18.26.07.55a.7.7 0 0 1-.4.42 1 1 0 0 1-.5.01 2 2 0 0 1-.6-.32 1 1 0 0 0-.32-.19 1 1 0 0 0-.4-.06q-.38 0-.62.16-.23.17-.23.4 0 .26.28.5t1.26.56a3.5 3.5 0 0 1 1.5.88q.47.53.47 1.4 0 .8-.57 1.4t-1.46.77v.13a.6.6 0 0 1-.17.46.6.6 0 0 1-.42.18" />
    <path
      fillRule="evenodd"
      d="M16 6.43H8a1 1 0 0 0-.71.29 1 1 0 0 0-.29.7q0 .44-.29.72a1 1 0 0 1-.71.29 1 1 0 0 0-.71.29 1 1 0 0 0-.29.7v9q0 1.26.88 2.13a3 3 0 0 0 2.12.88h8q1.24 0 2.13-.88a3 3 0 0 0 .87-2.12v-9a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.3 1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.7-.3ZM8.13 9.56q.5-.51.7-1.13h6.34A3 3 0 0 0 17 10.26v8.17a1 1 0 0 1-.29.7 1 1 0 0 1-.7.3H8a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7v-8.17a3 3 0 0 0 1.13-.7"
    />
  </svg>
)
export default SvgTipJar
